export default {
    LOGIN: '/',
    REGISTRATION: '/register',
    LAYOUT: '/layout',
    DASHBOARD: '/dashboard',
    SEARCH: '/search',
    INSIGHTS: '/insights',
    MY_LIST: '/myList',
    MY_SAVED_SEARCH: '/mySavedSearch',
    MY_PREFERENCES: '/myPreferences',
    MY_KOGNETICS: '/myKognetics',

    PROFILE_PAGE: '/profile/:entity/:name',
    COMPANY_PROFILE: '/companyProfile/:entity/:name',
    INVESTOR_PROFILE: '/investorProfile/:entity/:name',
    // GLOBAL_SEARCH: '/globalSearch',
    TEST: '/test',
    STACK_PROCESSING: '/stackProcessing'
}